import Layout from '@/layout'
const jxsaccountRouter = {
  path: '/jxs/account',
  component: Layout,
  name: 'jxsAccount',
  meta: {
    title: '账号管理',
    icon: 'el-icon-user',
    roles: ['root']
  },
  children: [

    {
      path: 'create',
      name: 'jxsAccountCreate',
      component: () => import('@/views/jxs/account/accountCreate'),
      meta: { title: '账号创建', icon: 'el-icon-plus', roles: ['root'], noCache: false }
    },
    {
      path: 'edit/:user_name',
      name: 'jxsAccountEdit',
      component: () => import('@/views/jxs/account/accountUpdate'),
      meta: { title: '账号更新', icon: 'el-icon-refrigerator', roles: ['root'], noCache: false },
      hidden: true
    },
    {
      path: 'table',
      name: 'jxsAccountTable',
      component: () => import('@/views/jxs/account/accountTable'),
      meta: { title: '账号列表', icon: 'el-icon-s-unfold', roles: ['root'], noCache: false }
    }
  ]
}
export default jxsaccountRouter
